import {
  IdentityDocumentType,
  MedicalServiceProviderType,
  MembershipStatus,
  MembershipType,
} from "@/services/core-api-adapter";

export function buildProductDetails(data?: any) {
  const productDetails = {
    name: "Template",
    friendlyName: "Template (friendlyName)",
    code: "Template",
    seriesName: "Template",
    termsAndConditionsUri:
      "https://api.develop.unuhealth.org/api/Contract/TERMS_AND_CONDITIONS/1/File.html",
    brochureUri:
      "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    imageUri: "https://placehold.co/28x32/green/white?text=S",
    startDate: "2022-06-27T11:19:20+00:00",
    medicalServiceProvider: MedicalServiceProviderType.WHATSAPP,
    provider: {
      id: "f350c1f0-c8f8-46d6-8aae-519b32d8e187",
      name: "Genric",
      description: null,
      imageUri:
        "/components/MembershipCard/logos/b958fa21-4fd4-49d3-9a07-ed33b314538e.png",
    },
    underwriter: {},
    administrator: {
      id: "bbb82cc0-9ea1-40be-8cb2-80e3bbdf7b61",
      code: "NHG",
      name: "National Health Group",
      imageUri:
        "/components/MembershipCard/logos/4529ef13-b948-44e0-8976-9a6ef9a0b34b.png",
      supportedServices: [
        {
          type: "CALL_CENTRE",
          channels: [
            {
              type: "PHONE",
              value: "+27123456789",
              availability: [],
            },
            {
              type: "EMAIL",
              value: "test@test.com",
              availability: [],
            },
            {
              type: "WHATSAPP",
              value: null,
              availability: [],
            },
          ],
        },
        {
          type: "MEDICAL_ASSISTANCE",
          channels: [
            {
              type: "PHONE",
              value: null,
              availability: [],
            },
            {
              type: "EMAIL",
              value: null,
              availability: [],
            },
            {
              type: "WHATSAPP",
              value: "+27727239355",
              availability: [],
            },
          ],
        },
        {
          type: "COUNSELLING_ASSISTANCE",
          channels: [
            {
              type: "PHONE",
              value: "+27860006969",
              availability: [],
            },
            {
              type: "EMAIL",
              value: null,
              availability: [],
            },
            {
              type: "WHATSAPP",
              value: null,
              availability: [],
            },
          ],
        },
      ],
    },
  };
  return {
    ...productDetails,
    ...data,
  };
}

export function buildMembership(data?: any) {
  const membership = {
    productDetails: buildProductDetails(),
    members: [
      {
        isPrimaryCard: true,
        membershipDetails: {
          id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
          type: MembershipType.MAIN_MEMBER,
          number: "Member565",
          status: MembershipStatus.ACTIVE,
          beneficiaryCode: "00",
        },
        memberDetails: {
          id: "7f37be7c-31dc-448b-a6b6-a9b64f1b01f2",
          memberFullName: "Lesedi Persona",
          identityDocumentType: IdentityDocumentType.IdNumber,
          identityDocumentValue: "9905275800085",
          dateOfBirth: "1996-03-12",
        },
      },
    ],
  };
  return {
    ...membership,
    ...data,
  };
}
